<template>
<w-sliding-popup ref="slidingPopup" type="setting" title="대상 설정" width="1200px" :default-content="false" @close="onClose">
  <div slot="content" class="body-content-no-scroll" style="height:100%;">
    <!-- 관리 대상 -->
    <div class="list-info mr-b20">
      <ul class="lists">
        <li v-for="(item, index) in predictRscCountList" :key="index">
          <span class="tit">{{item.predictRscLabel}} :</span>
          <span class="high">{{item.predictRscCount}}개</span>
          <span>(최대 {{item.maxPredictRsc}}개 설정 가능)</span>
        </li>
      </ul>
    </div>
    <div style="height:100%; width: 500px; margin-right:20px; float:left;">
      <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
        <div class="title-h4">관리 대상</div>
      </el-row>
      <hr class="mr-b10" />
      <w-setting-target-obj-tree ref="settingTargetObjTree" :obj-view-type="objViewType" @setSelectedNode="setSelectedNode"></w-setting-target-obj-tree>
    </div>
    <!-- 자원 설정 -->
    <div style="height:100%; width:calc(100% - 520px); float:right;">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div>
          <span class="title-h4">{{rscSettingTitle}}</span>
        </div>
        <div>
          <el-button size="mini" type="primary" :disabled="isDisabledSave" @click="savePredictInfo">저장</el-button>
          <el-button size="mini" :disabled="isDisabledSave" @click="revertRscTableInfo">취소</el-button>
          <w-header-search-button size="mini" @click="rscShowSearchTool = !rscShowSearchTool"></w-header-search-button>
        </div>
      </el-row>
      <el-table-wrapper style="height:calc(100% - 41px);" :data="targetPredictTableData" :columns="targetPredictTableColumn" ref="predictTable" @select="targetSelectionChange" @select-all="checkSelectionAll" :total="total" :pagination="true"
        :fit-height="true" :show-search-tool="rscShowSearchTool" :show-custom-header="true" @condition-change="reload">
        <template slot-scope="scope" slot="important-rsc-slot">
          <span @click="checkImportantRsc(scope)">
            <i v-if="scope.row.importantRsc === true || scope.row.importantRsc === 1" class="text-medium fas fa-check-square state-normal c-pointer" />
            <i v-else class="text-medium fal fa-square c-pointer" />
          </span>
        </template>
      </el-table-wrapper>
    </div>
  </div>
  <!-- </div> -->
</w-sliding-popup>
</template>

<script>
import { isNil, isEmpty, cloneDeep, find, findIndex, isEqual, uniqBy } from 'lodash';
import msgUtil from '@/utils/message';
import EventPredictSettingsAPI from '@/api/settings/common/event-predict-settings';
import WSettingTargetObjTree from '@/views/settings/operation/BasicInfoSettings/EventPredictSetting/components/SettingTargetObjTree';

/**
 * 이벤트 예측 대상 자원 설정 팝업
 * @author Ju
 */
export default {
  name: 'WEditTargetSettingPopup',
  components: {
    WSettingTargetObjTree,
  },
  data() {
    return {
      /**
       * 관리 대상 VIEW 타입 (논리/물리)
       * @type {String}
       */
      objViewType: null,
      selectedObj: null,
      rscShowSearchTool: false,
      isDisabledSave: true,
      // 초기값과 비교를 위한 체크 리스트 설정
      originCheckList: [],
      selectionList: [],
      originTableData: [],
      total: 0,
      targetPredictTableData: [],
      targetPredictTableColumn: [
        {
          // align: 'center',
          type: 'selection',
        },
        {
          prop: 'rsctypeName',
          label: '자원 구분',
          headerAlign: 'center',
          remoteProp: 'rt.rsctype_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'rscName',
          label: '자원',
          headerAlign: 'center',
          remoteProp: 'r.rsc_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'rscKey',
          label: '자원키',
          headerAlign: 'center',
          remoteProp: 'ork.rsc_key',
          sortable: true,
          searchable: true,
        },
        {
          label: '주요자원',
          headerAlign: 'center',
          align: 'center',
          // sortable: true,
          scopedSlot: 'important-rsc-slot',
          prop: 'importantRsc',
          renderCustomHeader: this.renderImportantRscHeader,
        },
      ],
      isFirstLoadTable: false,
      predictRscCountList: [],
      checked: false,
    };
  },
  computed: {
    /**
     * 이벤트 예측 자원 설정 타이틀
     * @author Ju
     * @return {String}
     */
    rscSettingTitle() {
      const title = '이벤트 예측 자원';
      return isNil(this.selectedObj) ? title : `[${this.selectedObj.objName}] ${title}`;
    },
  },
  watch: {
    selectedObj: {
      handler(to) {
        if (!isEmpty(to)) {
          this.$refs.predictTable.clearFilter();
          this.selectionList = [];
          this.targetPredictTableData = [];
          this.loadTargetEventPredictInfo();
          this.loadMaxPredictBasicInfo();
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * 팝업을 연다.
     * @author Ju
     */
    open() {
      this.objViewType = 'PHYSICAL';
      this.$refs.slidingPopup.open();
      // this.objViewType = 'LOGICAL';
      this.loadMaxPredictBasicInfo();
    },
    /**
     * 팝업 close 이벤트 핸들러
     * @author Ju
     */
    onClose() {
      this.selectedObj = null;
      this.objViewType = null;
      this.rscShowSearchTool = false;
      this.targetPredictTableData = [];
      this.predictRscCountList = [];
      this.checked = false;
      this.$refs.predictTable.clearFilter();
      this.$refs.settingTargetObjTree.initData();
      this.$emit('reload');
    },
    /**
     * 이벤트 예측 자원 목록을 설정한다.
     * @author yelim
     */
    loadTargetEventPredictInfo() {
      const tableParams = this.$refs.predictTable.getParameter();
      const params = {
        objId: this.selectedObj.objId,
        ...tableParams,
      };
      EventPredictSettingsAPI.getSettingEventPredictRscByTree(params).then((response) => {
        if (response.data.success) {
          const tableRef = this.$refs.predictTable.$children[0];
          this.originTableData = cloneDeep(response.data.data);
          this.targetPredictTableData = response.data.data;
          this.total = response.data.total;
          this.$nextTick(() => {
            // 로드된 목록이 자원으로 선택되어 있는 경우 그리드에 check 설정을 한다.
            this.targetPredictTableData.forEach((item) => {
              if (item.checkPredict === 1) {
                this.originCheckList.push(item);
                this.selectionList.push(item);
                tableRef.toggleRowSelection(item);
              }
            });
            this.isFirstLoadTable = true;
            if (isEmpty(this.selectionList)) {
              this.isDisabledSave = true;
            }
          });
        }
      });
    },
    /**
     * 설정 가능한 최대 개수, 현재 장비에서 설정된 자원 갯수를 로드한다.
     * @author yelim
     * @return {[type]}
     */
    loadMaxPredictBasicInfo() {
      EventPredictSettingsAPI.getMaxPredictCoverage().then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          const resultArr = [];
          result.maxPredictRscCount.forEach((item) => {
            if (item.moduleType === 'IMPORTANT') {
              resultArr.push({
                moduleType: 'IMPORTANT',
                predictRscLabel: '주요 예측 자원',
                predictRscCount: result.currentCount.curImportantPredictRscCnt,
                originPredictRscCount: result.currentCount.curImportantPredictRscCnt,
                maxPredictRsc: !isNil(item.predictRscCount) ? item.predictRscCount : 0,
              });
            } else {
              resultArr.push({
                moduleType: 'TARGET',
                predictRscLabel: '예측 자원',
                predictRscCount: result.currentCount.curPredictRscCnt,
                originPredictRscCount: result.currentCount.curPredictRscCnt,
                maxPredictRsc: !isNil(item.predictRscCount) ? item.predictRscCount : 0,
              });
            }
          });
          const targetIndex = findIndex(resultArr, (item) => item.moduleType === 'TARGET');
          const importantIndex = findIndex(resultArr, (item) => item.moduleType === 'IMPORTANT');
          if (targetIndex < 0) {
            resultArr.push({
              moduleType: 'TARGET',
              predictRscLabel: '예측 자원',
              predictRscCount: result.currentCount.curPredictRscCnt,
              originPredictRscCount: result.currentCount.curPredictRscCnt,
              maxPredictRsc: 0,
            });
          }
          if (importantIndex < 0) {
            resultArr.push({
              moduleType: 'IMPORTANT',
              predictRscLabel: '주요 예측 자원',
              predictRscCount: result.currentCount.curImportantPredictRscCnt,
              originPredictRscCount: result.currentCount.curImportantPredictRscCnt,
              maxPredictRsc: 0,
            });
          } else if (resultArr[targetIndex].maxPredictRsc < resultArr[importantIndex].maxPredictRsc) {
            resultArr[importantIndex].maxPredictRsc = resultArr[targetIndex].maxPredictRsc;
          }
          this.predictRscCountList = resultArr;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '최대 예측 자원 설정 정보', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '최대 예측 자원 설정 정보', false));
        throw new Error(e);
      });
    },
    /**
     * 선택한 이벤트 예측 자원을 리스트에 설정
     * @author yelim
     */
    targetSelectionChange(rows, row) {
      let changeFlag = true;
      if (this.originCheckList.length !== rows.length) {
        changeFlag = false;
      } else {
        rows.forEach((targetItem) => {
          const findChange = find(this.originCheckList, (originInfo) => originInfo.hashKeyIdString === targetItem.hashKeyIdString);
          if ((findChange.checkPredict !== targetItem.checkPredict)) {
            changeFlag = false;
          }
        });
      }
      if (this.isFirstLoadTable === true) {
        const findOriginChange = find(this.originTableData, (originInfo) => originInfo.hashKeyIdString === row.hashKeyIdString);
        const majorInfoIndex = findIndex(this.predictRscCountList, (item) => item.moduleType === 'IMPORTANT');
        const majorCountInfo = this.predictRscCountList[majorInfoIndex];
        const targetTableData = this.targetPredictTableData;
        const toggleCheckData = findIndex(targetTableData, (item) => row.hashKeyIdString === item.hashKeyIdString);
        targetTableData[toggleCheckData].checkPredict = targetTableData[toggleCheckData].checkPredict === 1 ? 0 : 1;
        if (!targetTableData[toggleCheckData].checkPredict && targetTableData[toggleCheckData].importantRsc) {
          this.predictRscCountList[majorInfoIndex].predictRscCount = majorCountInfo.predictRscCount - 1;
          targetTableData[toggleCheckData].importantRsc = 0;
        }
        const countInfo = this.predictRscCountList;
        const countInfoIndex = findIndex(countInfo, (item) => item.moduleType === 'TARGET');
        const targetCountInfo = this.predictRscCountList[countInfoIndex];
        if (row.checkPredict) {
          if (targetCountInfo.predictRscCount + 1 <= targetCountInfo.maxPredictRsc) {
            this.predictRscCountList[countInfoIndex].predictRscCount = targetCountInfo.predictRscCount + 1;
          } else {
            targetTableData[toggleCheckData].checkPredict = 0;
            this.$refs.predictTable.$children[0].toggleRowSelection(targetTableData[toggleCheckData]);
            this.$message(msgUtil.getCustomMsgData('최대 설정 개수를 초과할 수 없습니다.'));
          }
          if (changeFlag && (targetTableData[toggleCheckData].importantRsc === findOriginChange.importantRsc)) {
            changeFlag = false;
          }
        } else {
          this.predictRscCountList[countInfoIndex].predictRscCount = targetCountInfo.predictRscCount - 1;
        }
        this.targetPredictTableData = targetTableData;
      }
      this.selectionList = uniqBy(rows, 'hashKeyIdString');
      this.isDisabledSave = changeFlag;
    },
    /**
     * 선택한 대상에 이벤트 예측 자원을 설정 및 삭제한다
     * @author yelim
     */
    savePredictInfo() {
      const insertList = [];
      const deleteList = [];

      const insertMajorList = [];
      const deleteMajorList = [];
      // 추가 목록
      this.selectionList.forEach((item) => {
        const findChange = find(this.originTableData, (originInfo) => originInfo.hashKeyIdString === item.hashKeyIdString);
        if (findChange) {
          if (!findChange.checkPredict) {
            insertList.push(item);
          }
        }
      });
      // 삭제 목록
      this.originTableData.forEach((item) => {
        const findChange = find(this.targetPredictTableData, (selectInfo) => selectInfo.hashKeyIdString === item.hashKeyIdString);
        if (item.checkPredict && !findChange.checkPredict) {
          deleteList.push(item);
        }
      });

      this.originTableData.forEach((item) => {
        const findChange = find(this.targetPredictTableData, (selectInfo) => selectInfo.hashKeyIdString === item.hashKeyIdString);
        if (item.importantRsc && !findChange.importantRsc) {
          deleteMajorList.push({
            hashKeyIdString: item.hashKeyIdString,
          });
        } else if (!item.importantRsc && findChange.importantRsc) {
          insertMajorList.push({
            hashKeyIdString: item.hashKeyIdString,
          });
        }
      });
      this.originCheckList = [];
      EventPredictSettingsAPI.setSettingEventPredictRsc({
        insertList,
        deleteList,
        insertMajorList,
        deleteMajorList,
      }).then((response) => {
        if (response.data.success) {
          this.loadTargetEventPredictInfo();
          this.isDisabledSave = false;
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '이벤트 예측 자원', true));
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '이벤트 예측 자원', false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '이벤트 예측 자원', false));
      });
    },
    /**
     * 취소 버튼을 누르면 원 상태로 복구한다.
     * @author yelim
     */
    revertRscTableInfo() {
      this.originCheckList = [];
      this.selectionList = [];
      this.checked = false;
      const tableRef = this.$refs.predictTable.$children[0];
      this.targetPredictTableData = cloneDeep(this.originTableData);
      this.loadMaxPredictBasicInfo();
      this.$nextTick(() => {
        this.targetPredictTableData.forEach((item) => {
          if (item.checkPredict === 1) {
            this.originCheckList.push(item);
            tableRef.toggleRowSelection(item);
          }
        });
      });
      this.isDisabledSave = true;
    },
    reload() {
      this.loadTargetEventPredictInfo();
      this.loadMaxPredictBasicInfo();
    },
    /**
     * 주요자원 클릭 시 데이터 감지
     * @author yelim
     */
    checkImportantRsc(rowInfo) {
      const targetRscInfoData = cloneDeep(this.targetPredictTableData);
      const findRowInfo = targetRscInfoData.findIndex((item) => rowInfo.row.hashKeyIdString === item.hashKeyIdString);
      const currentImportantFlag = rowInfo.row.importantRsc;

      // 주요 예측 자원 갯수 가져옴
      const countInfoIndex = findIndex(this.predictRscCountList, (item) => item.moduleType === 'IMPORTANT');
      const targetCountInfo = this.predictRscCountList[countInfoIndex];
      // 예측 자원 갯수 가져옴
      const targetIndex = findIndex(this.predictRscCountList, (item) => item.moduleType === 'TARGET');
      const targetInfo = this.predictRscCountList[targetIndex];
      targetRscInfoData[findRowInfo].importantRsc = !(currentImportantFlag);
      // 현재 row가 주요자원으로 설정되어 있지 않은 경우
      if (!currentImportantFlag) {
        // 최대 설정 개수를 판단한다.
        if ((targetCountInfo.predictRscCount + 1 <= targetCountInfo.maxPredictRsc) &&
          (targetInfo.predictRscCount + 1 <= targetInfo.maxPredictRsc)) {
          if (!targetRscInfoData[findRowInfo].checkPredict) {
            this.predictRscCountList[targetIndex].predictRscCount = targetInfo.predictRscCount + 1;
          }
          targetRscInfoData[findRowInfo].checkPredict = 1;
          this.predictRscCountList[countInfoIndex].predictRscCount = targetCountInfo.predictRscCount + 1;
        } else {
          targetRscInfoData[findRowInfo].importantRsc = 0;
          targetRscInfoData[findRowInfo].checkPredict = 0;
          this.$refs.predictTable.$children[0].toggleRowSelection(targetRscInfoData[findRowInfo]);
          this.$message(msgUtil.getCustomMsgData('최대 설정 개수를 초과할 수 없습니다.'));
        }
      } else {
        this.predictRscCountList[countInfoIndex].predictRscCount = targetCountInfo.predictRscCount - 1;
      }
      this.targetPredictTableData = targetRscInfoData;
      const tableRef = this.$refs.predictTable.$children[0];
      this.$nextTick(() => {
        let changeFlag = true;
        const checkOriginInfo = find(this.originTableData, (originItem) => originItem.hashKeyIdString === rowInfo.row.hashKeyIdString);
        const compareOrigin = (checkOriginInfo.importantRsc === 1) || (checkOriginInfo.importantRsc === true) ? 1 : 0;
        const compareTarget = (targetRscInfoData[findRowInfo].importantRsc === 1) || (targetRscInfoData[findRowInfo].importantRsc === true) ? 1 : 0;
        if (compareTarget !== compareOrigin) {
          changeFlag = false;
        }
        this.targetPredictTableData.forEach((item) => {
          const checkInfo = findIndex(this.selectionList, (selection) => selection.hashKeyIdString === item.hashKeyIdString);
          if (!isNil(checkInfo) && item.checkPredict) {
            tableRef.toggleRowSelection(item);
          }
          const chekingFlag = find(this.originTableData, (originInfo) => originInfo.hashKeyIdString === item.hashKeyIdString);
          if ((chekingFlag.checkPredict !== item.checkPredict)) {
            changeFlag = false;
          }
        });
        const checkInfo = findIndex(this.selectionList, (selection) => selection.hashKeyIdString === rowInfo.row.hashKeyIdString);
        if (checkInfo < 0) {
          this.selectionList.push(targetRscInfoData[findRowInfo]);
        }
        this.isDisabledSave = changeFlag;
      });
    },
    /**
     * 트리 컴포넌트에서 선택한 obj를 받아온다.
     * @author yelim
     * @param  {[type]} objNode [description]
     */
    setSelectedNode(objNode) {
      this.isFirstLoadTable = false;
      this.originCheckList = [];
      this.selectedObj = objNode;
    },
    checkSelectionAll(selection) {
      // all selection 이벤트는 모두 선택하거나 선택을 해제하는 경우밖에 없음.
      const allSelectionList = cloneDeep(selection);
      const targetTableData = this.targetPredictTableData;
      const countInfo = this.predictRscCountList;
      const countInfoIndex = findIndex(countInfo, (item) => item.moduleType === 'TARGET');
      const targetCountInfo = this.predictRscCountList[countInfoIndex];
      this.$nextTick(() => {
        // 전체 선택이 해제된 경우
        if (isEmpty(selection)) {
          targetTableData.forEach((item) => {
            if (item.checkPredict) {
              item.importantRsc = false;
              item.checkPredict = !(item.checkPredict);
              this.predictRscCountList[countInfoIndex].predictRscCount = targetCountInfo.predictRscCount - 1;
            }
          });
          // 기존값 또한 비어있는 경우 disabled true
          if (isEmpty(this.selectionList)) {
            this.isDisabledSave = true;
          } else {
            this.isDisabledSave = false;
          }
          this.selectionList = [];
        } else {
          allSelectionList.forEach((selectionInfo, index) => {
            const toggleCheckData = findIndex(targetTableData, (item) => selectionInfo.hashKeyIdString === item.hashKeyIdString);
            if (!(targetTableData[toggleCheckData].checkPredict)) {
              if (targetCountInfo.predictRscCount + 1 <= targetCountInfo.maxPredictRsc) {
                targetTableData[toggleCheckData].checkPredict = !(targetTableData[toggleCheckData].checkPredict);
                this.predictRscCountList[countInfoIndex].predictRscCount = targetCountInfo.predictRscCount + 1;
              } else {
                targetTableData[index].checkPredict = 0;
                this.$refs.predictTable.$children[0].toggleRowSelection(targetTableData[index]);
              }
            }
          });
          this.isDisabledSave = false;
          this.selectionList = uniqBy(selection, 'hashKeyIdString');
        }
        this.targetPredictTableData = targetTableData;
        this.selectionList = isEmpty(selection) ? [] : uniqBy(selection, 'hashKeyIdString');
      });
    },
    /**
     * 주요 자원 헤더 아이콘 클릭 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    clickImportantRscHeaderIcon() {
      this.checked = !this.checked;
      // 현재 설정된 이벤트 예측 자원
      const targetTableData = this.targetPredictTableData;
      // 예측 자원 갯수 가져옴
      const predictTargetIdx = findIndex(this.predictRscCountList, (item) => item.moduleType === 'TARGET');
      const predictTargetInfo = this.predictRscCountList[predictTargetIdx];
      // 주요 예측 자원 갯수 가져옴
      const countInfoIndex = findIndex(this.predictRscCountList, (item) => item.moduleType === 'IMPORTANT');
      const targetCountInfo = this.predictRscCountList[countInfoIndex];
      const targetRscInfoData = cloneDeep(this.targetPredictTableData);
      // 선택된 이벤트 예측 자원의 관리를 위함
      const selectPredictList = [];
      this.isDisabledSave = false;
      targetRscInfoData.forEach((targetInfo) => {
        const findChange = findIndex(targetTableData, (originInfo) => originInfo.hashKeyIdString === targetInfo.hashKeyIdString);
        // 주요자원 헤더에 checked가 true인 경우
        if (this.checked) {
          // 1. 원래 주요자원이 아니었는데 주요자원으로 바뀌는 경우
          if (!targetTableData[findChange].importantRsc) {
            if (targetCountInfo.predictRscCount + 1 <= targetCountInfo.maxPredictRsc) {
              targetTableData[findChange].importantRsc = 1;
              this.predictRscCountList[countInfoIndex].predictRscCount = targetCountInfo.predictRscCount + 1;
            }
            // 예측자원으로 설정되어 있지 않은 경우 (importantRsc === 1, checkPredict === 0)
            if (!targetTableData[findChange].checkPredict || targetTableData[findChange].checkPredict === 0) {
              if (predictTargetInfo.predictRscCount + 1 <= predictTargetInfo.maxPredictRsc) {
                this.predictRscCountList[predictTargetIdx].predictRscCount = predictTargetInfo.predictRscCount + 1;
                targetTableData[findChange].checkPredict = 1;
                selectPredictList.push(targetTableData[findChange]);
                // 기본적으로 예측 자원으로 설정되어 있는 경우/주요 자원으로 설정 시 예측자원으로 설정되는 경우를 위함
                this.$nextTick(() => {
                  this.$refs.predictTable.$children[0].toggleRowSelection(targetTableData[findChange]);
                });
              } else {
                targetTableData[findChange].checkPredict = 0;
              }
            } else {
              selectPredictList.push(targetTableData[findChange]);
              targetTableData[findChange].checkPredict = 1;
            }
          }
        } else if (targetTableData[findChange].importantRsc) {
          // 주요자원 헤더가 checked가 false이지만 importantRsc가 true인 경우는 체크를 해제한다.
          if (targetTableData[findChange].checkPredict) {
            selectPredictList.push(targetTableData[findChange]);
          }
          this.predictRscCountList[countInfoIndex].predictRscCount = targetCountInfo.predictRscCount - 1;
          targetTableData[findChange].importantRsc = 0;
        }
      });
      this.selectionList = selectPredictList;
      this.targetPredictTableData = targetTableData;
    },
    /**
     * 주요 자원 헤더 renderer
     * @author Ju
     * @param  {[type]} h      [description]
     * @param  {[type]} column [description]
     * @return {[type]}        [description]
     */
    renderImportantRscHeader(h, { column }) {
      const me = this;
      return h(
        'i',
        {
          on: {
            click: me.clickImportantRscHeaderIcon,
          },
          class: `text-medium c-pointer ${this.checked ? 'fas fa-check-square state-normal' : 'fal fa-square'}`,
          style: 'margin-left:4px; margin-bottom:2px;',
        },
      );
    },
    /**
     * 주요 자원 헤더 renderer
     * @author Ju
     * @param  {[type]} h      [description]
     * @param  {[type]} column [description]
     * @return {[type]}        [description]
     */
    // renderImportantRscHeader(h, { column }) {
    //   console.debug('test', h, column);
    //   const me = this;
    //   return h(
    //     'el-checkbox',
    //     {
    //       on: {
    //         input: (e) => {
    //           console.debug(e);
    //           me.checked = e;
    //         },
    //         // change: me.clickImportantRscHeaderIcon,
    //       },
    //       props: {
    //         value: me.checked,
    //         checked: me.checked,
    //       },
    //     },
    //   );
    // },
  },
};
</script>

<style lang="scss" scoped>
//list info
//url
$url: '../../../../../assets/img/';

.list-info {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    min-height: 50px;
    border: 1px solid #e9e9e9;
    background-color: #f1f1f1;
    // margin-bottom: 10px;
    padding: 4px 18px;

    & > .select {
        padding: 4px 0;
    }
    .select > .tit {
        padding-right: 10px;
        font-size: 14px;
        letter-spacing: -1px;
    }

    .custom-input {
        margin-left: 4px;

        &:first-child {
            margin-left: 0;
        }
    }

    .lists {
        display: inline-block;
        align-items: center;
        padding: 5px 0;

        & > li {
            margin-right: 10px;
            //padding-left: 10px;
            // background: url($url + 'dot.png') no-repeat 0 5px;
            font-weight: 500;
            display: inline;
            width: 40%;

            &:first-child {
                //margin-left: 0;
                //padding-left: 0;
            }
        }
        & > li > .tit {
            display: inline-block;
            padding-right: 4px;
            font-size: 13px;
            letter-spacing: -1px;
        }
        .high {
            color: #1c768d;
            margin-right: 6px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/EventPredictSetting/TargetSetting/popup/EditTargetSettingPopup.vue